import ViewBase from "../../../../framework/core/mvvm/view_base";
import { UITableView, ScrollDirection, ScrollItemData } from "../../../../framework/tools/tableview/UITableView";
import { GameChatCell } from "./component/game_chat_cell";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GameChatView extends ViewBase {
    @property([cc.Toggle])
    toggles:cc.Toggle[] = [];

    @property([cc.Node])
    nodes:cc.Node[] = [];

    @property(cc.ScrollView)
    chatScrollView: cc.ScrollView = null;

    @property(cc.Mask)
    chatViewMask: cc.Mask = null;

    @property(cc.Node)
    chatldContent: cc.Node = null;

    @property(cc.Node)
    chatPrefab: cc.Node = null;

    @property(cc.EditBox)
    editorBox:cc.EditBox = null;

    mChatTableView: UITableView = null;

    showUIFunc:Function = null;

    init(func:Function){
        this.bindEvent();
        this.clickToggle(0);
        this.initTableView();
        this.showUIFunc = func;
    }

    initTableView(){
        this.mChatTableView = new UITableView({
            scrollview: this.chatScrollView,
            mask: this.chatViewMask,
            content: this.chatldContent,
            item_templates: [{
                key: 'normal',
                node: this.chatPrefab,
                item_class: GameChatCell
            }],
            direction: ScrollDirection.Vertical,
        })
    }

    private bindEvent(){
        let self = this;
        for (let idx = 0; idx < this.toggles.length; idx++) {
            let toggle = this.toggles[idx];
            toggle.node.on('toggle', function (event: cc.Toggle) {
                if (toggle.isChecked) {
                    for (let i = 0; i < self.nodes.length; i++) {
                        let node = self.nodes[i];
                        node.active = (i== idx);
                        self.showUIFunc && self.showUIFunc(i);
                    }
                }          
            })
        }
    }

    setData(chatMsgList: any[]) {
        let chatmsg: ScrollItemData[] = [];
        for (let i = 0; i < chatMsgList.length; i++) {
            let msg = chatMsgList[i];

            let data: ScrollItemData = {
                key: 'normal',
                data: {
                    data: msg
                },
            }
            chatmsg.push(data);
        }

        this.mChatTableView.set_data(chatmsg);
        this.mChatTableView.scroll_to_end();
    }

    appendOne(chatData: any,isNeedEnd: boolean = false) {
        let data: ScrollItemData = {
            key: 'normal',
            data: {
                data: chatData,
            },
        }
        this.mChatTableView.append_data(data);
        if (isNeedEnd) {
            this.mChatTableView.scroll_to_end();
        }
    }

    clickToggle(index:number){
        this.toggles[index].node.emit('toggle');
        this.toggles[index].check();
    }
}
